// 统一使用相对路径，生产环境由 nginx 反向代理，开发环境由 proxyTable 代理
const admin_api = '/admin';

const upload_url = '/index/upload_img';

export default {
  upload_url,
  admin_api,
}



// WEBPACK FOOTER //
// ./src/util/common.js